import React, { Component } from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { injectIntl } from 'react-intl';

import EcModalCard from '../../Shared/EcModalCard/EcModalCard';
import EcSelect from '../../Shared/EcSelect/EcSelect';

class MoveFieldToSectionModal extends Component {
  constructor(props) {
    super(props);

    this.state = { sections: [] };

    this.handleActionClick = this.handleActionClick.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidMount() {
    const { sections } = this.props;
    this.setState({
      sections: sections.map((s) => ({
        value: s.name,
        label: s.name,
        id: s.id,
      })),
      selectedSection: this.props.selectedSection
        ? {
            label: this.props.selectedSection.label,
            value: this.props.selectedSection.value,
            id: this.props.selectedSection.id,
          }
        : {},
    });
  }

  handleActionClick() {
    const { fieldId, handleActionClick, hideModal } = this.props;
    const { selectedSection } = this.state;
    handleActionClick(fieldId, selectedSection.id);
    hideModal();
  }

  handleOnChange(selectedSection) {
    this.setState({ selectedSection });
  }

  render() {
    const { text, hideModal, intl } = this.props;
    const { sections, selectedSection } = this.state;

    return (
      <EcModalCard
        title={intl.formatMessage({
          id: 'MoveFieldToSectionModal.title',
          defaultMessage: 'Move Field To Section',
          description: 'Modal title for moving field to section',
        })}
        content={
          <div>
            {text}
            <EcSelect
              data-testid="data-fields-section-options-selection-menu"
              width="100%"
              {...(selectedSection && {
                value: {
                  label: selectedSection.label,
                  value: selectedSection.value,
                },
              })}
              options={sections}
              onChange={this.handleOnChange}
            />
          </div>
        }
        footer={
          <>
            <Button
              variant="tertiary"
              text={intl.formatMessage({
                id: 'MoveFieldToSectionModal.cancelButton',
                defaultMessage: 'Cancel',
                description: 'Cancel button text',
              })}
              onClick={hideModal}
            />
            <Button
              variant="primary"
              text={intl.formatMessage({
                id: 'MoveFieldToSectionModal.moveButton',
                defaultMessage: 'Move',
                description: 'Move button text',
              })}
              onClick={this.handleActionClick}
            />
          </>
        }
        hideModal={hideModal}
      />
    );
  }
}

export default injectIntl(MoveFieldToSectionModal);
